module.exports = __webpack_public_path__ + "img/12.ed2148c7.jpg";